import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import HomeViamao from '../views/HomeViamao.vue'
import HomeFarroupilha from '../views/HomeFarroupilha.vue'
import Botoes from '../views/Botoes.vue'
import CadastroVisitante from '../views/cadastro/Visitante.vue'
import Parque from '../views/selecione/Parque.vue'
import Passaporte from '../views/selecione/Passaporte.vue'
import LoginVisitante from '../views/login/Visitante.vue'
import LoginSocio from '../views/login/Socio.vue'
import PagamentoSelecione from '../views/pagamento/Selecione.vue'
import PagamentoDebito from '../views/pagamento/Debito.vue'
import PagamentoCredito from '../views/pagamento/Credito.vue'
import PagamentoBanricompras from '../views/pagamento/Banricompras.vue'
import PagamentoPix from '../views/pagamento/Pix.vue'
import PagamentoBoleto from '../views/pagamento/Boleto.vue'
import Voucher from '../views/Voucher.vue'
import VoucherNaoPago from '../views/VoucherNaoPago.vue'
import VoucherUtilizado from '../views/VoucherUtilizado.vue'
import MeusPedidos from '../views/MeusPedidos.vue'
import AreaSocio from '../views/socio/AreaSocio.vue'
import RenovacaoTaxas from '../views/socio/RenovacaoTaxas.vue'
import AtualizacaoCadastral from '../views/socio/AtualizacaoCadastral.vue'
import ExtratoFinanceiro from '../views/socio/ExtratoFinanceiro.vue'
import Sitemap from '../views/Sitemap.vue'
import SobreViamao from '../views/viamao/Sobre.vue'
import SobreFarroupilha from '../views/farroupilha/Sobre.vue'
import Thermas from '../views/farroupilha/Thermas.vue'
import JeitoCampeiro from '../views/viamao/JeitoCampeiro.vue'
import AssocieseViamao from '../views/viamao/Associese.vue'
import AssocieseFarroupilha from '../views/farroupilha/Associese.vue'
import ExcursoesFarroupilha from '../views/farroupilha/Excursoes.vue'
import ExcursoesViamao from '../views/viamao/Excursoes.vue'
import ContatoViamao from '../views/viamao/Contato.vue'
import ContatoFarroupilha from '../views/farroupilha/Contato.vue'
import Caxias from '../views/farroupilha/Caxias.vue'
import PortoAlegre from '../views/viamao/PortoAlegre.vue'
import Trocas from '../views/institucional/Trocas.vue'
import store from '@/store'

Vue.use(VueRouter)
/* eslint-disable */
const routes: Array<RouteConfig> = [
  { path: '/', name: 'Parque', component: Parque },
  // { path: '/viamao', name: 'HomeViamao', component: HomeViamao },
  // { path: '/farroupilha', name: 'HomeFarroupilha', component: HomeFarroupilha },
  // { path: '/botoes', name: 'Botoes', component: Botoes },
  // { path: '/sitemap', name: 'Sitemap', component: Sitemap },
  // { path: '/sobre/viamao',   alias: '/Sobre-o-Via-Park-World', name: 'SobreViamao', component: SobreViamao },
  // { path: '/sobre/farroupilha', alias: '/thermas-clube-parque-das-aguas-farroupilha', name: 'SobreFarroupilha', component: SobreFarroupilha },
  // { path: '/thermas', alias: '/Thermas-Clube', name: 'Thermas', component: Thermas },
  // { path: '/excursoes/farroupilha', name: 'ExcursoesFarroupilha', component: ExcursoesFarroupilha },
  // { path: '/excursoes/viamao', name: 'ExcursoesViamao', component: ExcursoesViamao },
  // { path: '/jeito-campeiro', name: 'JeitoCampeiro', component: JeitoCampeiro },
  // { path: '/caxias-do-sul', name: 'Caxias', component: Caxias },
  // { path: '/porto-alegre', alias: '/Sobre-o-Clube-de-Viamao', name: 'PortoAlegre', component: PortoAlegre },
  // { path: '/trocas', name: 'Trocas', component: Trocas },
  // { path: '/associe-se/viamao', name: 'AssocieseViamao', component: AssocieseViamao },
  // { path: '/associe-se/farroupilha', name: 'AssocieseFarroupilha', component: AssocieseFarroupilha },
  // { path: '/contato/viamao', name: 'ContatoViamao', component: ContatoViamao },
  // { path: '/contato/farroupilha', alias: '/contato-parque-farroupilha', name: 'ContatoFarroupilha', component: ContatoFarroupilha },
  
  // { path: '/cadastro/visitante', name: 'CadastroVisitante', component: CadastroVisitante, meta: { title: 'Cadastro de Visitante' } },
  {
    path: '/selecione/passaporte',
    name: 'Passaporte',
    component: Passaporte,
    // eslint-disable-next-line
    beforeEnter: (from, to, next) => {
      if ((store.state.carrinho.parque == '') && (store.state.carrinho.data == '')) {
        store.dispatch('setMensagemErro', 'Você deve selecionar o parque e a data da visita antes de selecionar o passaporte')
      } else {
        store.commit('setMostraCarrinho', true)
        store.commit('limpaCarrinho')
        next()
      }
    }, meta: { title: 'Cadastro a Promoção' }
  },
  { path: '/login/visitante', name: 'LoginVisitante', component: LoginVisitante, meta: { title: 'Login Visitante' } },
  { path: '/login/socio', name: 'LoginSocio', component: LoginSocio, meta: { title: 'Login Sócio' } },
  {
    path: '/pagamento/selecione',
    name: 'PagamentoSelecione',
    component: PagamentoSelecione,
    beforeEnter: (from, to, next) => {
      store.commit('setMostraCarrinho', false)
      if ((store.getters.totalCarrinho > 0) || (store.getters.totalCarrinhoTarifas > 0)) {
        if (store.state.logadoSocio || store.state.logadoVisitante) {
          next()
          return
        }
      }
      store.dispatch('setMensagemErro', 'O Seu carrinho não está completo, você será direcionado ao início do processo de compra')
    }, meta: { title: 'Selecione a Forma de Pagamento' }
  },
  { path: '/pagamento/debito', name: 'PagamentoDebito', component: PagamentoDebito, meta: { title: 'Débito' } },
  {
    path: '/pagamento/credito',
    name: 'PagamentoCredito',
    component: PagamentoCredito,
    beforeEnter: (from, to, next) => {
      if ((store.getters.totalCarrinho > 0) || (store.getters.totalCarrinhoTarifas > 0)) {
        if (store.state.logadoSocio || store.state.logadoVisitante) {
          next()
          return
        }
      }
      store.dispatch('setMensagemErro', 'O Seu carrinho não está completo, você será direcionado ao início do processo de compra')
    }, meta: { title: 'Crédito' }
  },
  { path: '/pagamento/banricompras', name: 'PagamentoBanricompras', component: PagamentoBanricompras, meta: { title: 'Banricompras' } },
  { path: '/pagamento/pix', name: 'PagamentoPix', component: PagamentoPix, meta: { title: 'Pix' } },
  { path: '/pagamento/boleto', name: 'PagamentoBoleto', component: PagamentoBoleto, meta: { title: 'Boleto' } },
  {
    path: '/pagamento/:voucher',
    name: 'PagamentoVoucherSelecione',
    component: PagamentoSelecione,
    beforeEnter: (from, to, next) => {
      store.commit('limpaCarrinho')
      store.dispatch('buscaVoucher', from.params.voucher).then(x => {
        console.log(x.data)
        store.commit('updateCarrinho', x.data.produtos)
        store.commit('setID', x.data)
        switch (x.data.status) {
          case 2:
            next('/voucher/' + from.params.voucher)
            break
          case 1:
            next()
            break
          case 3:
            store.dispatch('setMensagemErro', 'Este voucher já foi utilizado, você será direcionado ao início do processo de compra')
            break
        }
      }).catch((erro) => {
        store.dispatch('setMensagemErro', erro + ', você será direcionado ao início do processo de compra')
      })
    }, meta: { title: 'Pagamento Pedido' }
  },
  {
    path: '/voucher/:id',
    name: 'Voucher',
    component: Voucher,
    beforeEnter: (from, to, next) => {
      store.commit('limpaCarrinho')
      store.dispatch('buscaVoucher', from.params.id).then(x => {
        console.log(x.data)
        switch (x.data.status) {
          case 2:
            next()
            break
          case 1:
            next('/voucher-nao-pago')
            break
          case 3:
            next('/voucher-utilizado')
            break
        }
      }).catch((error) => {
        console.log(error)
        next('/')
      })
    }, meta: { title: 'Voucher' }
  },
  { path: '/voucher-nao-pago', name: 'VoucherNaoPago', component: VoucherNaoPago, meta: { title: 'Voucher não pago' } },
  { path: '/voucher-utilizado', name: 'VoucherUtilizado', component: VoucherUtilizado, meta: { title: 'Voucher já utilizado' } },
  // {
  //   path: '/meus-pedidos',
  //   name: 'MeusPedidos',
  //   component: MeusPedidos,
  //   beforeEnter: (from, to, next) => {
  //     store.commit('limpaCarrinho')
  //     store.dispatch('meusPedidos').then(() => {
  //       next()
  //     }).catch((error) => {
  //       console.log(error)
  //       next('/')
  //     })
  //   }, meta: { title: 'Meus Pedidos' }
  // },
  {
    path: '/socio/area-socio',
    alias: '/area-do-socio-parque-farroupilha',
    name: 'AreaSocio',
    component: AreaSocio,
    meta: { title: 'Área do Sócio' },
    beforeEnter: (from, to, next) => {
      if (store.state.logadoSocio) {
        next()
      } else {
        next('/login/socio')
      }
    }
  },
  { path: '/socio/renovacao-taxas', name: 'RenovacaoTaxas', component: RenovacaoTaxas, meta: { title: 'Renovação das Taxas' },
  beforeEnter: (from, to, next) => {
    if (store.state.logadoSocio) {
      next()
    } else {
      next('/login/socio')
    }
  } },
  { path: '/socio/atualizacao-cadastral', name: 'AtualizacaoCadastral', component: AtualizacaoCadastral, meta: { title: 'Atualização Cadastral' } },
  { path: '/socio/extrato-financeiro', name: 'ExtratoFinanceiro', component: ExtratoFinanceiro, meta: { title: 'Extrato Financeiro' } },
  { path: '*', name: 'Erro404', component: Home }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' - Parque das Águas';
  } else {
    document.title = 'Clube Parque das Águas em Farroupilha e Viamão'
  }
});

export default router
